import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { toBoolean } from '../core/convert';

@Component({
  selector: 'jd-form-item',
  template: `
    <ng-content></ng-content>
  `,
  host: {
    '[class.ant-form-item]': 'true',
    '[class.ant-form-item-with-help]': 'withHelp>0'
  },
  styles: [``]
})
export class JdFormItemComponent implements OnInit {
  private _flex = false;
  withHelp = 0;

  @Input()
  set nzFlex(value: boolean) {
    this._flex = toBoolean(value);
    if (this._flex) {
      this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'flex');
    } else {
      this.renderer.removeStyle(this.elementRef.nativeElement, 'display');
    }
  }

  enableHelp(): void {
    this.withHelp++;
  }

  disableHelp(): void {
    this.withHelp--;
  }

  constructor(private renderer: Renderer2, private elementRef: ElementRef) {

  }

  ngOnInit() {
  }

}
